import React, { useEffect, useState, useRef } from 'react';
import '@zebra-fed/icons/Enterprise/index.css';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Link from '@material-ui/core/Link';
import MaterialTable from 'material-table';
import styled from 'styled-components';
import Pagination from './reports/dailyeventdetailreport/components/Pagination';
import { tableIcons } from './reports/dailyeventdetailreport/components/TableIcons';
import { PageTitle } from '../styled-components/shared';
import ApsToolbar from './users/components/ApsToolbar';
import { useAuthContext } from '../authentication/Auth';
import app from '../authentication/firebaseStart';
import { useTranslation } from "react-i18next";
import { DLR_MACHINE_LEARNING } from '../data/constants';
import { useHistory } from 'react-router-dom';
import Snackbar from "@material-ui/core/Snackbar";
import InfoIcon from '@material-ui/icons/Info';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { SnackbarContent } from "../styled-components/shared";
import Checkbox from '@material-ui/core/Checkbox';
import './css/machineLearning.css'
const PAGE_SIZE = 10;
const PAGE_LENGTH = [10, 25, 50, 100];

const firestore = app.firestore();

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
`;

const SiteBar = styled.div`
    display: flex;
    justifyContent: space-between;
    @media (maxWidth: : 1024px) {
      flex-direction: column;
    }
`;

const EligibleSiteContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 9px 6px;
    gap: 10px;
    width: 320px;
    height: 31px;
    background: #F1F8FF;
    border-radius: 4px;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin-top: 32px;
    margin-right: 10px;
`;

const defaultSite = "Select Site";

function MachineLearningPage() {
    //Loader
    const [isLoading, setIsLoading] = useState(false);
    const [isSiteActivationDialogOpen, setIsSiteActivationDialogOpen] = useState(false);
    //pagination
    const [TotalData, setTotalData] = useState(0);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageDirection, setPageDirection] = useState(1);
    //data
    const [data, setData] = useState([]);
    const context = useAuthContext();
    const [isMlPredictionEnabled, setIsMlPredictionEnabled]= useState(false);
    const [SiteList, setSiteList] = useState([])
    const [selectedSite, setSelectedSite]= useState("")
    const [isButtonDisable, setIsButtonDisable] = useState(false)
    const [status, setStatus] = useState(null);
    const [isUpdated, setIsUpdated] = useState(false);
    const [activeEligibleSiteList, setActiveEligibleSiteList] = useState([]);
    const [siteSelectedForActivation, setSiteSelectedForActivation] = useState([])
    const companyID = context.currentUser.claims.companyID;
    const { t } = useTranslation();
    //filter
    const [ML_SEARCH_FILTER, set_ML_SEARCH_FILTER] = useState(['', ''])
    // snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const serverResponse = useRef("");
    // Page History
    const history= useHistory();
    let snapshotListener;
    let globalSelectedSite = sessionStorage.getItem("selectedSite");

  useEffect(()=> {
    checkMlActiveStatus();
  },[]);

  useEffect(()=> {
    if(isMlPredictionEnabled){
      getSiteLists();
      getActivateEligibleSites();
    }
  },[isMlPredictionEnabled]);

  useEffect(()=> {
    if(selectedSite!==defaultSite)
      setIsButtonDisable(true)
    else
      setIsButtonDisable(false);

    if(isMlPredictionEnabled){
      getMlReadinessData();
    }
  },[isMlPredictionEnabled, pageSize, currentPage, ML_SEARCH_FILTER, selectedSite]);

  useEffect(()=> {
    if(isMlPredictionEnabled){
      getSiteStatus();
    }

    return () => {
      if(snapshotListener)  snapshotListener();
    }
  },[selectedSite]);

  useEffect(() => {
    if(isUpdated){
      setIsUpdated(false);
      onRefreshClick();
    }
  }, [status]);

  const resolveBatchPromise = async batch => {
    try{
      await batch.commit();
    }
    catch(err){
      console.log(err);
    }
  }

  const getReadyStateValue = state => {
    state = state.trim().toLowerCase();
    state = state.charAt(0).toUpperCase() + state.slice(1);
    console.log(state);
    let status = -1;
    for(let i in DLR_MACHINE_LEARNING.READY_STATUS){
      if(DLR_MACHINE_LEARNING.READY_STATUS[i].text === state){
        status = i;
        break;
      }
    }
    console.log(status);
    return Number(status);
  }

  const checkMlActiveStatus = async () => {
    setIsLoading(true)
    try{
      const checkData = (
        await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRConfig")
            .get()
      ).data();
      if(checkData && (checkData.MLPredictionStatus)===DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE){
        setIsMlPredictionEnabled(true);
      }
      else{
        setIsMlPredictionEnabled(false);
        setIsLoading(false);
      }
    }
    catch(Err){
      console.log(Err);
    }
  }

  const getActivateEligibleSites = async () => {
    try{
      console.log("inside getActivateEligibleSites ");
      const eligibleCriteria = [DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.NOT_ACTIVE, DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.DEACTIVE]
      const sitesSnap = (await firestore.collection('tenants')
                        .doc(companyID)
                        .collection('SiteModelMLPrediction')
                        .where("activationState", "in", eligibleCriteria)
                        .get())

      const sites = [];
      for(let i=0; i<sitesSnap.docs.length;i++){
        let data = sitesSnap.docs[i].data()
        if(data.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.READY || 
          data.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.DEACTIVE)
          {
            sites.push(sitesSnap.docs[i].id);
          }
      }
      console.log("sites ",sites);
      setActiveEligibleSiteList(sites);
    }
    catch(err){
      console.log(err);
    }
  }

  const getSiteLists = async () => {
    setIsLoading(true);
    try{
      if(SiteList.length == 0){
        const sites = (await firestore.collection('tenants')
                          .doc(companyID)
                          .collection('SiteModelMLPrediction')
                          .get()).docs.map((doc) => doc.id)

        const index = sites.indexOf("UNASSIGNED");
        if(index > -1){
          sites.splice(index, 1);
          sites.unshift("UNASSIGNED");
        }
        sites.unshift(defaultSite);
        setSiteList(sites);
        if(globalSelectedSite == null || globalSelectedSite == "" || globalSelectedSite == "All Devices"){
          setSelectedSite(defaultSite);
        }
        else if(globalSelectedSite == "Unassigned Devices"){
          setSelectedSite("UNASSIGNED")
        }
        else{
          setSelectedSite(globalSelectedSite);
        }
      }
    }
    catch(err){
      console.log(err);
    }
  }

  const getSiteStatus = () => {
    try{
      snapshotListener = firestore
      .collection('tenants')
      .doc(companyID)
      .collection('SiteModelMLPrediction')
      .doc(selectedSite)
      .onSnapshot((querySnapshot)=>{
        if(typeof querySnapshot.data()!== typeof undefined){
          let snapshot = querySnapshot.data();
          if(snapshot){
            getActivateEligibleSites();
            console.log(snapshot);
            if(snapshot.readyState === DLR_MACHINE_LEARNING.READY_STATUS_VALUES.ACTIVE && 
                snapshot.activationState === DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.DEACTIVE){
              snapshot.readyState = DLR_MACHINE_LEARNING.READY_STATUS_VALUES.DEACTIVATION_PROGRESS;
            }
            else if(snapshot.readyState === DLR_MACHINE_LEARNING.READY_STATUS_VALUES.DEACTIVE && 
                  snapshot.activationState === DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.ACTIVE){
              snapshot.readyState = DLR_MACHINE_LEARNING.READY_STATUS_VALUES.ACTIVATION_PROGRESS;
            }
            else if(snapshot.readyState === DLR_MACHINE_LEARNING.READY_STATUS_VALUES.READY && 
                    snapshot.activationState === DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.ACTIVE){
              snapshot.readyState = DLR_MACHINE_LEARNING.READY_STATUS_VALUES.ACTIVATION_PROGRESS;
            }
            setStatus(snapshot);
          }
        }
      })
    }
    catch(err){
      console.log(err);
    }
  }

  const getMlReadinessData = async () => {
    try{
      console.log(selectedSite);
      setIsLoading(true);
      let QUERY = firestore
              .collection('tenants')
              .doc(companyID)
              .collection('SiteModelMLPrediction')
              .doc(selectedSite)
              .collection("ModelMLPrediction")

        if(ML_SEARCH_FILTER[0] === "modelNumber"){
          QUERY = QUERY.where(ML_SEARCH_FILTER[0], "==", ML_SEARCH_FILTER[1].toUpperCase());
        }
        else if(ML_SEARCH_FILTER[0] === "readyState"){
          QUERY = QUERY.where(ML_SEARCH_FILTER[0], "==", getReadyStateValue(ML_SEARCH_FILTER[1]));
        }

        setTotalData(await QUERY.get().then((snapshot) => snapshot.size));

        if(currentPage > 0){
          console.log(pageDirection);
          if(pageDirection > 0)
            QUERY = QUERY.orderBy("modelNumber").startAfter(data[data.length-1].modelNumber).limit(pageSize);
          else if(pageDirection < 0)
            QUERY = QUERY.orderBy("modelNumber").endBefore(data[0].modelNumber).limitToLast(pageSize);
        }
        else{
          QUERY = QUERY.limit(pageSize);
        }

        let models = [];

        try{
          models = (await QUERY.get()).docs.map((doc) => {
            return { siteName: selectedSite,...doc.data()}
          });
        }
        catch(err){
          console.log(err);
        }

      console.log(models);

      setData(models);

      setIsLoading(false);
    }
    catch(err){
      console.log(err);
    }
  }

  const getSiteName = site => {
    if(site === "UNASSIGNED"){
      return "Unassigned Devices"
    } 
    return site;
  }

  const onPageChange = direction => {
    setPageDirection(direction);
    setCurrentPage(direction == 0 ? 0 : currentPage + direction);
  }

  const onRefreshClick = () => {
    if(isMlPredictionEnabled){
      setCurrentPage(0);
      getMlReadinessData();
    }
  }

  function goToThresholdPage () {
    history.push('/settings/auto/workflow-automation');
  }

  function getEmptyDataSource() {
    if(!isMlPredictionEnabled){
      return(
        <>
          <h4>{t("machineLearningPage.thereNothingHereYet")}</h4>
          <Link id='viewMachineLearning-link' onClick={goToThresholdPage} underline="always">
              {t('machineLearningPage.viewMachineLearning')}
            </Link>
        </>
      )
    }
    else{
      if(!isLoading){
      return(
        <span>No Data Found</span>
      )
    }}
  }

  function changesite() {
    return selectedSite;
  }

  async function ChangeActivation() {
    let activation
    if(status.activationState===DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.DEACTIVE  || status.activationState===DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.NOT_ACTIVE){
      activation = DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.ACTIVE;
      serverResponse.current = {
        status: 200,
        msg: t("messages.success.success10")
      };
    }
    else{
      activation=DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.DEACTIVE;
      serverResponse.current = {
        status: 200,
        msg: t("messages.success.success11")
      };
    }

    try{
      await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('SiteModelMLPrediction')
            .doc(selectedSite)
            .update({activationState: activation});

      console.log("update done");
      setSnackbarOpen(true);
      setIsUpdated(true);
    }
    catch(err){
      console.log(err);
    }
  }

  const selectSiteForActivation = (site, isChecked) => {
    console.log("selectSiteForActivation is called ", site, isChecked)
    if(isChecked){
      if(site == "all"){
        setSiteSelectedForActivation([...activeEligibleSiteList]);
      }
      else{
        let sites = siteSelectedForActivation;
        sites.push(site);
        setSiteSelectedForActivation([...sites]);
      }
    }
    else{
      if(site == "all"){
        setSiteSelectedForActivation([]);
      }
      else{
        let sites = siteSelectedForActivation;
        const index = sites.indexOf(site);
        if (index > -1) {
          sites.splice(index, 1);
        }
        setSiteSelectedForActivation([...sites]);
      }
    }
    console.log("activeEligibleSiteList ",activeEligibleSiteList);
  }

  const activateMultipleSites = async () => {
    setIsLoading(true);
    console.log("siteSelectedForActivation ",siteSelectedForActivation);
    let batchArray = [];
    let promise = [];
    batchArray.push(firestore.batch());
    let batchSize = 0;
    let currentBatch = 0;
    for(let i=0; i< siteSelectedForActivation.length; i++){

      let esRef = firestore
              .collection('tenants')
              .doc(companyID)
              .collection('SiteModelMLPrediction')
              .doc(siteSelectedForActivation[i])

      batchArray[currentBatch].update(esRef, {activationState: DLR_MACHINE_LEARNING.ACTIVATION_STATE_VALUES.ACTIVE });
      batchSize++;

      if(batchSize == 500){
        batchArray.push(firestore.batch());
        promise.push(resolveBatchPromise(batchArray[currentBatch]));
        currentBatch++;
        batchSize = 0;
      }
    }
    if(batchSize > 0){
      promise.push(resolveBatchPromise(batchArray[currentBatch]));
    }

    try{
      await Promise.all(promise);

      await firestore.collection("tenants")
            .doc(companyID).collection("Configuration")
            .doc("AppSettings").collection("DLRSettings")
            .doc("DLRBulkSiteActivation").set({
              startedAt: Date.parse(new Date)
            }, { merge: true })

    }
    catch(err){
      console.log(err);
    }
    serverResponse.current = {
        status: 200,
        msg: t("messages.success.success10")
    };
    setIsLoading(false);
    setSnackbarOpen(true);
    setActiveEligibleSiteList([]);
    setIsSiteActivationDialogOpen(false);
  }

    
    return(
      <PageWrapper id='pageWrapper' data-testid="pageWrapper" style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
            <div id='titleContainer' style={{ display: 'flex', alignItem: 'center', justifyContent: 'space-between', marginBottom: '50px' }}>
              <PageTitle id='pageTitle' data-testid="pageTitle">{t('machineLearningPage.machineLearning')}</PageTitle>
              <div style={{ display: "flex" }}>
                {isMlPredictionEnabled && 
                  <EligibleSiteContainer >
                    <InfoIcon /> 
                    <span data-testid='eligibleCount'>{activeEligibleSiteList.length} {t('machineLearningPage.activeEligibleSiteText')}</span>
                    <button
                      id="activeViewBtn"
                      data-testid="activeViewBtn"
                      style={{
                        padding: '8px 16px',
                        backgroundColor: activeEligibleSiteList.length > 0 ? '#007ABA' : '#c4c7c8',
                        borderRadius: 4,
                        fontFamily: "Segoe UI",
                        border: '1px solid ',
                        position: 'inline',
                        color: ' #fff',
                        fontWeight: 500,
                        fontSize: '12px',
                        cursor: activeEligibleSiteList.length > 0 ? 'pointer' : 'default',
                        height: 'fit-content',
                        alignItems: 'center'
                      }}
                      disabled={ activeEligibleSiteList.length > 0 ? false : true }
                      onClick={()=> { setIsSiteActivationDialogOpen(true); setSiteSelectedForActivation([]); }}
                    >{t('machineLearningPage.button.view')}</button>
                  </EligibleSiteContainer>
                }
                <button
                  id="configureBtn"
                  data-testid="configureBtn"
                  style={{
                    padding: '13.5px 20px',
                    backgroundColor: '#007ABA',
                    borderRadius: 4,
                    fontFamily: "Segoe UI",
                    border: '1px solid ',
                    position: 'inline',
                    color: ' #fff',
                    fontWeight: 500,
                    fontSize: '15px',
                    cursor: 'pointer',
                    height: 'fit-content',
                    margin: 'auto 0',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={goToThresholdPage}
                >
                  {t('machineLearningPage.button.configure')}
                </button>
              </div>
            </div>
            {isMlPredictionEnabled && 
              <SiteBar id='toolbar'>
                <Select
                  label="Site"
                  labelId="demo-simple-select-label"
                  style={{"width":"200px","height":"48px","border":"2px solid","borderRadius":"5px","borderColor":"#E0E3E9","padding":"10px","marginBottom":"10px"}}
                  id="siteDropdown"
                  data-testid="siteDropdown"
                  value={changesite()}
                  onChange={(e)=>{
                    console.log(e.target.value)
                    setSelectedSite(e.target.value)
                  }}
                >
                  {SiteList.map((option, index) => {return (<MenuItem disabled={index==0?true:false} key={option} value={option}>{ getSiteName(option) }</MenuItem>)})}
                </Select>
                {(status && isButtonDisable) &&
                    <div style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      '@media (maxWidth: 1024px)': {
                        marginLeft: 0
                      }
                    }} >
                      <span>
                        Status: 
                        <span style={{"color": DLR_MACHINE_LEARNING.READY_STATUS[status.readyState].color}} id='siteStatus' data-testid="siteStatus"> {DLR_MACHINE_LEARNING.READY_STATUS[status.readyState].text}</span>
                      </span>
                      <Button 
                        id='activateBtn'
                        data-testid="activateBtn"
                        style={{ marginLeft: "10px" }}
                        variant="outlined" 
                        color={ DLR_MACHINE_LEARNING.ACTIVATION_STATE[status.activationState]?.color } 
                        disabled={ 
                            status.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.LEARNING || 
                            status.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.PROCESSING || 
                            status.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.NA ||
                            status.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.DEACTIVATION_PROGRESS ||
                            status.readyState == DLR_MACHINE_LEARNING.READY_STATUS_VALUES.ACTIVATION_PROGRESS
                          }
                        onClick={ChangeActivation}
                      >{ DLR_MACHINE_LEARNING.ACTIVATION_STATE[status.activationState]?.text }
                      </Button>
                    </div>
                }
              </SiteBar>
            }

            <MaterialTable
              id="readinessTable"
              data-testid="readinessTable"
              isLoading={isLoading} 
              columns={[
                { title: <p className='machine-learning-table-padding'>Site Name</p>, field: 'siteName', sorting: false,
                    render: rowData =>{
                      return(
                        <p className='machine-learning-table-padding'><span>{getSiteName(rowData.siteName)}</span></p>
                      )
                    }
                },
                { title: t('deviceModel'), field: 'modelNumber'},
                { title: t('startDate'), field: 'startOn',
                  render: rowData =>{
                    let date='';
                    if(rowData.startOn)
                      date=rowData.startOn.substr(0,10)
                    return(
                      <span>{date}</span>
                    )
                  }
                },
                { title: 'Completion Date', field: 'endOn',
                  render: rowData =>{
                    let date='';
                    if(rowData.endOn)
                      date=rowData.endOn.substr(0,10)
                    return(
                      <span>{date}</span>
                    )
                  }
                },
                { title: 'Status',
                  render: rowData => <span style={{ color: DLR_MACHINE_LEARNING.READY_STATUS[rowData.readyState].color }}>{ DLR_MACHINE_LEARNING.READY_STATUS[rowData.readyState].text }</span> 
                }
              ]}

              options={{
                // actionsColumnIndex: 2,
                paginationType: 'stepped',
                search: true,
                minBodyHeight: '350px',
                maxBodyHeight: '400px',
                paging: data.length > 0 ? true : false,
                pageSize: pageSize,
                pageSizeOptions: PAGE_LENGTH,
                cspNonce: window.NONCE_ID,
                emptyRowsWhenPaging: false,
                sorting: true,
                draggable: false,
                sortRequest: (event, property) => console.log(event, property)
                // onRequestSort: (event, property) => console.log(event, property)
              }}
              icons={tableIcons}
              localization={{
                body: {
                  emptyDataSourceMessage: getEmptyDataSource(),
                },
              }}
              data={data}
              title=""
              onChangeRowsPerPage={(val) =>{ setPageSize(val); setCurrentPage(0)}}
              components={{
                Pagination: (props) => (
                  <Pagination
                    id="readinessTablePagination"
                    {...props}
                    itemCount={TotalData}
                    currentPage={currentPage}
                    onNextClicked={() => { onPageChange(1) }}
                    onPrevClicked={() => { onPageChange(-1) }}
                  />
                ),
                Toolbar: (props) => (
                  <ApsToolbar
                    id="siteModelSearching"
                    disabled={!isMlPredictionEnabled}
                    titleProp={'Site Model Prediction'}
                    searchText={ML_SEARCH_FILTER[1]}
                    onSearch={(searchVal, searchOptVal) => { set_ML_SEARCH_FILTER([searchOptVal, searchVal]); setCurrentPage(0) } }
    
                    multiSearchOpts={
                      [{
                        id: 'deviceModelSearch',
                        name: 'Device Model',
                        value: 'modelNumber',
                        disable: false
                      },
                      {
                        id: 'readyStateSearch',
                        name: 'Status',
                        value: 'readyState',
                        disable: false
                      }]
                    }
                    onClear={(searchVal) => { set_ML_SEARCH_FILTER(['', '']); setCurrentPage(0) } }
                    onRefreshClick={() => onRefreshClick()}
    
                  />
                ),
              }}
          />
          <Snackbar
              id='snackbar'
              open={snackbarOpen}
              autoHideDuration={5000}
              onClose={() => setSnackbarOpen(false)}
          >
              <SnackbarContent error={serverResponse.current.status ? false : true}>
                  {serverResponse.current.msg}
              </SnackbarContent>
          </Snackbar>
          <Dialog
            fullWidth
            maxWidth="xs"
            scroll="paper"
            open={isSiteActivationDialogOpen}
          >
            <DialogTitle id='activateDialogTitle'>
              <div style={{ display: "flex" }}>
                <span>
                {t('machineLearningPage.eligibleSiteHeading')}
                </span>
                <FormControlLabel
                  style={{ marginLeft: "auto" }}
                  id='site-all'
                  value={"all"}
                  key={"all"}
                  control={<Checkbox id='check-all' checked={ siteSelectedForActivation.length == activeEligibleSiteList.length } onChange={e => { selectSiteForActivation("all", e.target.checked) }}/>}
                  label={t('machineLearningPage.allSite')}
                />
              </div>
            </DialogTitle>
            <DialogContent dividers style={{ display: "flex", flexDirection: "column", paddingLeft: "50px" }}>
              {activeEligibleSiteList.map((option) => (
                  <FormControlLabel
                    id={`site-${option}`}
                    value={option}
                    key={option}
                    control={<Checkbox id={`check-${option}`} checked={siteSelectedForActivation.includes(option)} onChange={e => selectSiteForActivation(option, e.target.checked)}/>}
                    label={getSiteName(option)}
                  />
                ))}
            </DialogContent>
            <DialogActions>
                <button
                  id="allCancelBtn"
                  data-testid="allCancelBtn"
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#fff',
                    borderRadius: 6,
                    fontFamily: "Segoe UI",
                    border: '1px solid #c4bdbd',
                    position: 'inline',
                    fontWeight: 500,
                    fontSize: '12px',
                    cursor: 'pointer',
                    height: 'fit-content',
                    margin: 'auto 0',
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '8px'
                  }}
                  onClick={()=> setIsSiteActivationDialogOpen(false)}
                >
                  {t('machineLearningPage.button.cancel')}
                </button>
              <button
                  id="allActivateBtn"
                  data-testid="allActivateBtn"
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#007ABA',
                    borderRadius: 6,
                    fontFamily: "Segoe UI",
                    border: '1px solid ',
                    position: 'inline',
                    color: ' #fff',
                    fontWeight: 500,
                    fontSize: '12px',
                    cursor: 'pointer',
                    height: 'fit-content',
                    margin: 'auto 0',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  disabled={!siteSelectedForActivation.length}
                  onClick={activateMultipleSites}
                >
                  {t('machineLearningPage.button.activate')}
                </button>
            </DialogActions>
          </Dialog>
        </PageWrapper>
    )
}
export default MachineLearningPage;